import { ComplianceDocument } from '@centecomm/portal-service';
import { DocumentLink } from '../../Types';

export const mapComplianceDocumentToDocumentLink = ({ name, link }: ComplianceDocument): DocumentLink => ({
    title: name,
    link,
    identifier: name,
});
